import { render, staticRenderFns } from "./VolumeAlert.vue?vue&type=template&id=562a5ec9&lang=pug"
import script from "./VolumeAlert.vue?vue&type=script&lang=js"
export * from "./VolumeAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports